import React, { FC, useEffect, useRef, useState } from 'react';
import { Add } from '@mui/icons-material';

import './AddPreferenceChip.scss';

interface AddPreferenceChipProps {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
}

const AddPreferenceChip: FC<AddPreferenceChipProps> = ({ value, onChangeText, placeholder }) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (!isEditing) return;
    const id = window.setTimeout(() => inputRef.current?.focus(), 50);
    return () => window.clearTimeout(id);
  }, [isEditing]);

  const handleBlur = () => {
    if (!value.trim()) {
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <textarea
        ref={inputRef}
        className="add-preference-chip__input"
        value={value}
        onChange={(event) => onChangeText(event.target.value)}
        placeholder={placeholder}
        onBlur={handleBlur}
        rows={2}
      />
    );
  }

  return (
    <button type="button" className="add-preference-chip" onClick={() => setIsEditing(true)}>
      <Add fontSize="small" />
      <span className="add-preference-chip__pencil" aria-hidden>
        ✏️
      </span>
    </button>
  );
};

export default AddPreferenceChip;
